<template>
    <div v-if="isreadshow">
        <my-search v-model="pgData" @search="searchHandler">
            <el-form-item slot="time">
                <el-input v-model="pgData.txtKey"  placeholder="通知书名称" clearable></el-input>
            </el-form-item>
            <el-form-item slot="title">
                <el-radio-group v-model="pgData.txtKey2" @change="searchHandler">
                    <el-radio-button label="1">未审核公告</el-radio-button>
                    <el-radio-button label="9">已审核公告</el-radio-button>
                </el-radio-group>
            </el-form-item>
        </my-search>
        <my-table :data="tableData" :height="tableHeight">
            <el-table-column label="标段名称" prop="bdname" min-width="220"></el-table-column>
            <el-table-column label="类型" prop="typename"></el-table-column>
            <el-table-column label="中标价格" prop="zbjg">
                <template slot-scope="scope">
                    <div v-if="scope.row.bjlx=='1'||scope.row.bjlx==''||scope.row.bjlx==null||scope.row.bjlx==undefined">
                        {{scope.row.zbjg}}{{scope.row.jgdwname}}{{scope.row.bzname}}
                    </div>
                    <div v-else>
                        {{scope.row.zbbj}}
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="发布时间" prop="addtime"></el-table-column>
            <el-table-column label="状态" prop="shbj">
                <template slot-scope="scope">
                    <my-tag type="warning" v-if="scope.row.shbj==='0'">
                        未提交
                    </my-tag>
                    <my-tag type="primary" v-if="scope.row.shbj==='1'">
                        已提交待审核
                    </my-tag>
                    <my-tag type="primary" v-if="scope.row.shbj==='8'">
                        平台内审核
                    </my-tag>
                    <my-tag type="danger" v-if="scope.row.shbj==='3'">
                        退回
                    </my-tag>
                    <my-tag type="success" v-if="scope.row.shbj==='9'">
                        已发布
                    </my-tag>
                </template>
            </el-table-column>
            <el-table-column label="操作" fixed="right">
                <template slot-scope="scope">                    
                    <my-btn type="detail" @click="detail(scope.row.tzscode)">详情</my-btn>            
                    <el-button icon="el-icon-finished"  type="text" @click="sh(scope.row.tzscode)" v-if="scope.row.shbj==='1'">审核</el-button>
                    <div v-if="scope.row.shbj==='9'" style="margin:10px 0;">{{scope.row.by5}}核实</div>
                </template>
            </el-table-column>
        </my-table>
        <my-pagination ref="page" v-model="tableData" :search="pgData" :action="`${getGetters('mngUrl')}/manage/business/audittzs/get_list.json`"></my-pagination>
        <my-dialog title="审核" v-model="dialogVisible">
            <formAudit @cancle="cancle" :rows="shrows"></formAudit>
        </my-dialog>
    </div>
</template>

<script>
import LIST_PAGE_MIXIN from '@views/mixins/list-page'
import formAudit from './sub-pages/form-audit'
export default {
    mixins: [LIST_PAGE_MIXIN],
    components:{
        formAudit
    },
    data() {
        return{
            shrows:'',
            dialogVisible:false,
            pgData:{
                txtKey:'',
                txtKey2: '1',
                sortname : 'addtime',              
            },
            isreadshow:true,
            tableData:[]
        }
    },
    computed: {
        
    },
    watch: {

    },
    methods: {
        cancle:function(data){
            if(data==='1'){
                this.reload();
                this.dialogVisible=false;
            }
        },
        sh:function(id){
            this.shrows=id
            this.dialogVisible=true;
        },
        //刷新
        reload:function(){
            var that = this;
            this.isreadshow=false;
            this.$nextTick(function(){
                that.isreadshow=true;
            })
        },
        //详情
        detail:function(id){
            this.$router.push({
                path:'./detail',
                query:{
                    id:id
                }
            });
        }
    },
    created() {
        
    },
    mounted() {
        
    }
}
</script>

<style scoped lang="scss">

</style>
